import SvgIcon from '@mui/material/SvgIcon';

export const MyServeIcon = () => (
  <SvgIcon
    width="59"
    height="74"
    viewBox="0 0 59 74"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M26.9912 55.1619C32.325 37.0919 37.6588 19.0219 42.9963 0.550917C47.4999 0.1499 52.0335 0.483918 56.4886 0.0369578C59.6607 -0.28128 58.9519 1.49552 58.6822 3.83224C57.2076 7.7643 56.0073 10.9993 54.901 14.2662C48.2553 33.89 41.6312 53.5212 34.9999 73.1499C32.2999 73.1499 29.5999 73.1499 26.4499 72.6829C26.3304 66.5313 26.6608 60.8466 26.9912 55.1619Z"
      fill="#81B0C8"
    />
    <path
      d="M26.6258 55.0152C26.6609 60.8466 26.3304 66.5313 26 72.6829C23.3 73.1499 20.6 73.1499 17.4496 72.7491C14.9873 66.2761 13.0826 60.1657 10.9394 54.1402C7.37342 44.1148 3.6545 34.1438 0 24.1499C0 23.0832 0 22.0166 0 20.5499C5.07366 20.4073 11.2787 18.9893 14.8829 21.423C18.0858 23.5858 18.4964 29.9904 19.9745 34.576C22.1468 41.3153 24.1723 48.1019 26.6258 55.0152Z"
      fill="#0C4766"
    />
  </SvgIcon>
);
